var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18CEF6",
    d: "M56.118,36.313c0-10.748-8.888-19.462-19.853-19.462c-10.965,0-19.853,8.714-19.853,19.462 c0,10.75,8.888,19.462,19.853,19.462C47.23,55.775,56.118,47.062,56.118,36.313z M27.859,35.554c-2.765,0-5.008-2.199-5.008-4.91 c0-2.711,2.242-4.909,5.008-4.909c2.765,0,5.008,2.198,5.008,4.909C32.867,33.354,30.624,35.554,27.859,35.554z M64.225,60.802 c-0.477-1.052-12.162-12.157-12.162-12.157L49.798,51.1c0,0,11.565,10.988,12.043,11.572C62.318,63.256,64.702,61.854,64.225,60.802 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#233251",
    d: "M64.416,59.511l-11.35-11.127c2.888-3.749,4.602-8.414,4.603-13.473 c-0.002-12.362-10.224-22.385-22.835-22.385c-12.61,0-22.832,10.023-22.833,22.385c0.002,12.362,10.224,22.383,22.833,22.385 c5.516-0.001,10.575-1.919,14.522-5.111l11.267,11.047c0.52,0.51,1.211,0.769,1.895,0.768h0.006c0.681,0,1.37-0.259,1.89-0.768 c0.523-0.515,0.787-1.192,0.787-1.861C65.201,60.703,64.938,60.023,64.416,59.511z M14.147,34.91 c0.02-11.199,9.262-20.261,20.686-20.281C46.259,14.65,55.5,23.711,55.521,34.91c-0.021,11.2-9.262,20.26-20.687,20.28 C23.409,55.17,14.167,46.11,14.147,34.91z M62.894,61.747c-0.102,0.098-0.234,0.149-0.377,0.149c-0.141,0-0.273-0.051-0.377-0.154 L50.945,50.769c0.254-0.247,0.501-0.502,0.743-0.761L62.899,61c0.105,0.103,0.155,0.23,0.156,0.37 C63.053,61.506,63.006,61.638,62.894,61.747z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9146d3d613b5134f4c7d97a13e85cee.svg";
export { ForwardRef as ReactComponent };